'use strict'

module.exports = {
    UPLOADED_FONT_PREFIX: 'wf_',
    LONG_UPLOADED_FONT_PREFIX: 'wfont_'
}


// WEBPACK FOOTER //
// ./src/coreUtils/src/main/fonts/constants.js